<template>
  <router-view />
  <AgeGate />
</template>

<script setup>
import AgeGate from '@/components/common/AgeGate.vue'
</script>
